import React from 'react'
import ReactDOM from 'react-dom/client' // Note the new import
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { QueryClientProvider, QueryClient } from 'react-query'
import './assets/css/global.css'
import './assets/css/rhybus.css'
import './assets/icons/style.css'
import './assets/css/rhybus-variables.css'
import { RefreshProvider } from './utils/refresh-context'
import { BrowserRouter } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from './authConfig'
import HashRedirectHandler from './HashRedirectHandler'
const queryClient = new QueryClient()
const msalInstance = new PublicClientApplication(msalConfig)
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter useTransitions={false}>
      <HashRedirectHandler/>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <RefreshProvider>
              <App />
            </RefreshProvider>
          </QueryClientProvider>
        </Provider>
      </BrowserRouter>
    </MsalProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
